module.exports = __webpack_public_path__ + "static/media/S.cc1375c2.jpg";